import { defineStore } from 'pinia'

export const useTenancyStore = defineStore('tenancy', {
    state: () => ({
        companies: [],
        activeCompanyId: parseInt(localStorage.getItem('cortex_company_id')) || null,
        enabledModules: [],
    }),

    getters: {
        activeCompany: (state) =>
            state.companies.find(c => c.id === state.activeCompanyId) ?? state.companies[0] ?? null,

        hasMultipleCompanies: (state) => state.companies.length > 1,
    },

    actions: {
        hydrateFromBootstrap(companies, modules) {
            this.companies = companies

            const ids = companies.map(c => c.id)
            if (!this.activeCompanyId || !ids.includes(this.activeCompanyId)) {
                this.activeCompanyId = companies[0]?.id ?? null
                if (this.activeCompanyId) {
                    localStorage.setItem('cortex_company_id', this.activeCompanyId)
                }
            }

            this.enabledModules = modules
        },

        switchCompany(id) {
            this.activeCompanyId = id
            localStorage.setItem('cortex_company_id', id)
            window.location.href = '/personal-assistant/assistant'
        },
    },
})
